<button #btnClose mat-button *ngIf="!data.disabledClose" class="close" (click) = "closeSnackbar()" aria-label="Close">
    <mat-icon matSuffix>close</mat-icon>
</button>
<section *ngIf="data.title" [class] ="'alert alert-' + data.messageType">
    <h3>{{ data.title }}</h3>
    <p *ngIf="!data.showTimer">{{ data.message }}</p>
    <p *ngIf="data.showTimer">{{ data.message }} {{ remainingTime.minutes }} {{ 'modal_deployment_timeout.min' |  translate}} {{ remainingTime.seconds }} {{ 'modal_deployment_timeout.sec' |  translate}}</p>
  </section>
<div *ngIf="!data.title" [class] ="'alert alert-' + data.messageType">
    <p>{{ data.message }}</p>
</div>
